const data = {
  title: "Floor 3-4",
  musicTrack: "MUSIC_WORLD3",
  theme: "PINK",
  tilesWidth: 11,
  tilesHeight: 5,
  placements: [
    {
      type: "HERO_SPAWN",
      x: 2,
      y: 3
    },
    {
      type: "PLACEMENT_TYPE_GOAL",
      x: 10,
      y: 3
    },
    {
      type: "FIRE",
      x: 6,
      y: 1
    },
    {
      type: "FIRE",
      x: 6,
      y: 2
    },
    {
      type: "FIRE",
      x: 6,
      y: 3
    },
    {
      type: "ENEMY_SPAWN",
      x: 10,
      y: 1,
      direction: "LEFT",
      enemyType: "ENEMY"
    },
    {
      type: "ENEMY_SPAWN",
      x: 10,
      y: 5,
      direction: "LEFT",
      enemyType: "ENEMY"
    },
    {
      type: "FIRE",
      x: 6,
      y: 4
    },
    {
      type: "FIRE",
      x: 6,
      y: 5
    },
    {
      type: "FIRE_BOOTS",
      x: 4,
      y: 3
    }
  ]
};

export default data;
